import { JsonPropertiesMapper as DefaultJsonPropertiesMapper } from 'jsona'

export class JsonPropertiesMapper extends DefaultJsonPropertiesMapper {
  createModel(type: string) {
    return { _type: type }
  }
}
